__webpack_require__.p = "https://fr-fund-holdings-fe.rc.securitize.io/";